  (function() {
    var section = document.querySelector('[data-pcg-section]');
    if (!section) return;

    function revealCards() {
      var els = section.querySelectorAll('.pcg-card, .pcg-promo');
      els.forEach(function(el, i) {
        el.style.setProperty('--pcg-delay', (i % 12) * 40 + 'ms');
        requestAnimationFrame(function() { el.classList.add('is-revealed'); });
      });
    }

    function buildUrl(extraParams) {
      var url = new URL(window.location.href);
      var toDelete = [];
      url.searchParams.forEach(function(v, k) {
        if (k.indexOf('filter.') === 0 || k === 'page') toDelete.push(k);
      });
      toDelete.forEach(function(k) { url.searchParams.delete(k); });
      var form = document.querySelector('[data-pcg-filters]');
      if (form) {
        var fd = new FormData(form);
        fd.forEach(function(v, k) {
          if (!v) return;
          if (k === 'sort_by') { url.searchParams.set(k, v); return; }
          url.searchParams.append(k, v);
        });
      }
      if (extraParams) {
        for (var k in extraParams) url.searchParams.set(k, extraParams[k]);
      }
      return url;
    }

    function fetchSection(url) {
      section.classList.add('is-loading');
      return fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-pcg-section]');
          if (fresh) {
            section.innerHTML = fresh.innerHTML;
            window.history.replaceState({}, '', url.toString());
            bindHandlers();
            revealCards();
          } else {
            window.location.href = url.toString();
          }
          section.classList.remove('is-loading');
        })
        .catch(function() {
          window.location.href = url.toString();
        });
    }

    function bindHandlers() {
      var form = document.querySelector('[data-pcg-filters]');
      if (form) {
        form.addEventListener('change', function(e) {
          if (e.target.matches('input')) fetchSection(buildUrl());
        });
        form.addEventListener('submit', function(e) { e.preventDefault(); fetchSection(buildUrl()); });
      }
      var sortSel = document.querySelector('[data-pcg-sort]');
      if (sortSel) {
        sortSel.addEventListener('change', function() {
          fetchSection(buildUrl({ sort_by: this.value }));
        });
      }
      var filterBtn = document.querySelector('.pcg-filter-btn');
      var panel = document.getElementById('pcg-filter-panel');
      var closeBtn = document.querySelector('.pcg-filters-close');
      function isDrawer() {
        return panel && getComputedStyle(panel).position === 'fixed';
      }
      if (filterBtn) filterBtn.addEventListener('click', function() {
        if (!isDrawer()) return;
        panel.classList.add('is-open');
        panel.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
      if (closeBtn) closeBtn.addEventListener('click', function() {
        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      });

      var loadMoreBtn = document.querySelector('[data-pcg-loadmore]');
      if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', function(e) {
          e.preventDefault();
          var nextUrl = this.getAttribute('href');
          if (!nextUrl) return;
          this.classList.add('is-loading');
          this.querySelector('span').textContent = 'Loading…';
          fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function(r) { return r.text(); })
            .then(function(html) {
              var parser = new DOMParser();
              var doc = parser.parseFromString(html, 'text/html');
              var freshGrid = doc.querySelector('[data-pcg-grid]');
              var grid = document.querySelector('[data-pcg-grid]');
              if (freshGrid && grid) {
                var newNodes = Array.from(freshGrid.children);
                newNodes.forEach(function(node, i) {
                  node.style.setProperty('--pcg-delay', (i % 12) * 40 + 'ms');
                  grid.appendChild(node);
                  requestAnimationFrame(function() { node.classList.add('is-revealed'); });
                });
                var freshLoadMore = doc.querySelector('[data-pcg-loadmore]');
                var wrap = loadMoreBtn.closest('.pcg-loadmore-wrap');
                if (freshLoadMore) {
                  loadMoreBtn.setAttribute('href', freshLoadMore.getAttribute('href'));
                  loadMoreBtn.classList.remove('is-loading');
                  loadMoreBtn.querySelector('span').textContent = 'Load more';
                  var freshFill = doc.querySelector('.pcg-progress-fill');
                  var freshText = doc.querySelector('.pcg-progress-text');
                  if (freshFill) document.querySelector('.pcg-progress-fill').style.width = freshFill.style.width;
                  if (freshText) document.querySelector('.pcg-progress-text').innerHTML = freshText.innerHTML;
                  window.history.replaceState({}, '', nextUrl);
                } else if (wrap) {
                  wrap.remove();
                }
              }
            })
            .catch(function() { window.location.href = nextUrl; });
        });
      }
    }

    var toolbar = section.querySelector('[data-pcg-toolbar]');
    if (toolbar && 'IntersectionObserver' in window) {
      var sentinel = document.createElement('div');
      sentinel.style.cssText = 'position:absolute;top:-1px;left:0;width:1px;height:1px;pointer-events:none';
      toolbar.parentNode.insertBefore(sentinel, toolbar);
      new IntersectionObserver(function(entries) {
        toolbar.classList.toggle('is-stuck', !entries[0].isIntersecting);
      }, { threshold: [1] }).observe(sentinel);
    }

    function bindChatTrigger() {
      var btns = document.querySelectorAll('[data-pcg-chat-trigger]');
      btns.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          var host = document.getElementById('printibly-chat-widget');
          if (host && host.shadowRoot) {
            var bubble = host.shadowRoot.querySelector('.pb-bubble');
            if (bubble) {
              e.preventDefault();
              bubble.click();
            }
          }
        });
      });
    }

    function bindSeoToggle() {
      var toggle = section.querySelector('[data-pcg-seo-toggle]');
      var body = section.querySelector('[data-pcg-seo-body]');
      if (!toggle || !body) return;
      if (body.scrollHeight <= 360) { toggle.style.display = 'none'; body.classList.add('is-expanded'); return; }
      var label = toggle.querySelector('[data-pcg-seo-toggle-label]');
      toggle.addEventListener('click', function() {
        var open = body.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (label) label.textContent = open ? 'View less' : 'Read more';
        toggle.classList.toggle('is-open', open);
      });
    }

    bindHandlers();
    bindChatTrigger();
    bindSeoToggle();
    revealCards();
  })();

/* ══ QUANTITY BAND — reprices every card in place ═══════════════════════════
   The grid's headline price is the ONE-UNIT price. Choosing a quantity here
   restates every card at that quantity, which is the whole point of the page:
   a buyer comparing 50 tees should not have to open a product to find out what
   50 costs.

   Rounding MUST match printibly-customizer.js getPricing()/calculatePricing and
   therefore the cart: the discount is floored PER COMPONENT, in cents. A flat
   rate on the combined figure lands 1-2c low, and low is the bad direction —
   the price would rise between this grid and the PDP.

   All arithmetic is integer cents. No float ever forms, so no card can drift. */
(function () {
  var KEY = 'pcg_qty';
  var qty = 1;

  function readQty() {
    try {
      var v = parseInt(sessionStorage.getItem(KEY), 10);
      if (v > 0) qty = v;
    } catch (e) { /* private mode — fall back to 1 */ }
  }
  function saveQty() {
    try { sessionStorage.setItem(KEY, String(qty)); } catch (e) {}
  }

  function money(cents) {
    var neg = cents < 0;
    cents = Math.abs(Math.round(cents));
    var s = (cents / 100).toFixed(2);
    var parts = s.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (neg ? '-' : '') + '$' + parts.join('.');
  }

  // Highest tier whose minQuantity the order reaches.
  function rateAt(tiers, q) {
    var pct = 0;
    for (var i = 0; i < tiers.length; i++) {
      if (q >= tiers[i].q && tiers[i].p > pct) pct = tiers[i].p;
    }
    return pct;
  }
  function eachCents(blank, print, pct) {
    var dg = Math.floor(blank * pct / 100);
    var dp = Math.floor(print * pct / 100);
    return blank + print - dg - dp;
  }

  function tiersOf(el) {
    try { return JSON.parse(el.getAttribute('data-tiers') || '[]'); } catch (e) { return []; }
  }

  function repriceCards() {
    var nodes = document.querySelectorAll('[data-pcg-price]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var blank = parseInt(el.getAttribute('data-blank'), 10);
      var print = parseInt(el.getAttribute('data-print'), 10);
      if (!(blank > 0) || !(print > 0)) continue;
      var tiers = tiersOf(el);
      var one = blank + print;
      var now = eachCents(blank, print, rateAt(tiers, qty));

      var amount = el.querySelector('[data-pcg-amount]');
      var was = el.querySelector('[data-pcg-was]');
      var suffix = el.querySelector('[data-pcg-suffix]');
      if (amount) amount.textContent = money(now);
      // The struck figure only appears when there IS a reduction — showing it
      // against an identical number reads as a fake discount.
      if (was) {
        if (now < one) { was.textContent = money(one); was.hidden = false; }
        else { was.textContent = ''; was.hidden = true; }
      }
      if (suffix) suffix.textContent = qty > 1 ? ('each at ' + qty) : 'each';

      var card = el.closest('.pcg-card') || el.parentNode;
      var total = card && card.querySelector('[data-pcg-total]');
      if (total) {
        if (qty > 1) { total.textContent = money(now * qty) + ' for ' + qty; total.hidden = false; }
        else { total.textContent = ''; total.hidden = true; }
      }
    }
  }

  function renderPills() {
    var wrap = document.querySelector('[data-pcg-qpills]');
    if (!wrap) return;
    var first = document.querySelector('[data-pcg-price]');
    var tiers = first ? tiersOf(first) : [];
    // Ladder comes from the products themselves, so a collection with a
    // different tier structure shows its own.
    var opts = [{ q: 1, label: 'just one' }];
    for (var i = 0; i < tiers.length; i++) {
      opts.push({ q: tiers[i].q, label: tiers[i].p + '% off' });
    }
    if (opts.length < 2) { wrap.parentNode.hidden = true; return; }
    wrap.innerHTML = '';
    opts.forEach(function (o) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pcg-qpill' + (o.q === qty ? ' is-active' : '');
      b.setAttribute('data-q', String(o.q));
      b.setAttribute('aria-pressed', o.q === qty ? 'true' : 'false');
      // The top band is open-ended, so it takes a plus — the same convention the
      // card strip uses (25+ / 50+ / 100+). The others are exact thresholds and
      // must not, or "10" would read as "10 or more" when 20 is the next step.
      var isLast = o.q !== 1 && o.q === opts[opts.length - 1].q;
      b.innerHTML = '<span class="pcg-qpill-n">' + o.q + (isLast ? '+' : '') + '</span>' +
                    '<span class="pcg-qpill-sub">' + o.label + '</span>';
      wrap.appendChild(b);
    });
  }

  function syncState() {
    var band = document.querySelector('[data-pcg-qband]');
    if (!band) return;
    var state = band.querySelector('[data-pcg-qstate]');
    var pills = band.querySelector('[data-pcg-qpills]');
    var copy = band.querySelector('.pcg-qband-copy');
    var collapsed = qty > 1 && band.getAttribute('data-open') !== '1';
    // Once chosen, the band states the current state rather than re-offering the
    // choice — six pills is a lot of permanent chrome on a phone, and Change
    // reopens them.
    if (state) {
      state.hidden = !collapsed;
      if (collapsed) {
        var first = document.querySelector('[data-pcg-price]');
        var pct = first ? rateAt(tiersOf(first), qty) : 0;
        var q = state.querySelector('[data-pcg-qstate-qty]');
        var o = state.querySelector('[data-pcg-qstate-off]');
        if (q) q.textContent = qty + ' units';
        if (o) { o.textContent = pct + '% OFF'; o.hidden = !(pct > 0); }
      }
    }
    if (pills) pills.hidden = collapsed;
    if (copy) copy.hidden = collapsed;
    band.classList.toggle('is-collapsed', collapsed);
  }

  function setQty(n) {
    qty = n > 0 ? n : 1;
    saveQty();
    var band = document.querySelector('[data-pcg-qband]');
    if (band) band.removeAttribute('data-open');
    renderPills();
    syncState();
    repriceCards();
  }

  document.addEventListener('click', function (e) {
    var pill = e.target.closest && e.target.closest('.pcg-qpill');
    if (pill) { setQty(parseInt(pill.getAttribute('data-q'), 10)); return; }
    var change = e.target.closest && e.target.closest('[data-pcg-qchange]');
    if (change) {
      var band = document.querySelector('[data-pcg-qband]');
      if (band) { band.setAttribute('data-open', '1'); syncState(); }
    }
  });

  function boot() { readQty(); renderPills(); syncState(); repriceCards(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Filters and sort re-render the grid over AJAX, which replaces the cards with
  // freshly-rendered one-unit prices. Re-apply the chosen quantity afterwards or
  // the page silently reverts to 1 the moment a filter is touched.
  //
  // Guarded, because repricing REPLACES text nodes and that is itself a childList
  // mutation — an unguarded observer would call itself forever. `busy` swallows
  // our own writes and the timeout coalesces a burst of replaced cards into one
  // pass instead of one per node.
  var busy = false, pending = 0;
  function reapply() {
    busy = true;
    try { renderPills(); syncState(); repriceCards(); }
    finally { setTimeout(function () { busy = false; }, 0); }
  }
  var mo = new MutationObserver(function () {
    if (busy) return;
    clearTimeout(pending);
    pending = setTimeout(reapply, 60);
  });
  // Observe the SECTION, not .pcg-grid. fetchSection does
  // `section.innerHTML = fresh.innerHTML`, which destroys .pcg-grid along with
  // the band — an observer bound to the grid is watching a detached node and
  // never fires again, so sorting or filtering silently reverted every price to
  // the one-unit figure while the pill still read 50. The section element itself
  // survives, so watching it keeps working across every re-render.
  var root = document.querySelector('[data-pcg-section]') || document.body;
  mo.observe(root, { childList: true, subtree: true });
})();

/* ══ HOW PRICING WORKS — modal ══════════════════════════════════════════════
   The worked example belongs behind a tap, not inline: on the page it made the
   explainer four blocks deep and buried the comparison table. The markup is
   server-rendered and hidden, so opening costs no request and the content is
   still in the HTML for an AI answer to lift.

   The trigger keeps its href="#pcg-pricing-explainer", so without JS it still
   goes somewhere useful instead of doing nothing. */
(function () {
  var modal, lastFocus;
  function open(e) {
    modal = document.querySelector('[data-pcg-p101m]');
    if (!modal) return;                      // no modal on this page — let the anchor scroll
    if (e) e.preventDefault();
    // position:fixed is relative to the nearest ancestor with a transform, filter or
    // will-change — not the viewport. The section around this markup has animated
    // ancestors, so inset:0 resolved against one of them and the sheet rendered
    // 198px wide on desktop and 41px on a phone. Reparenting to <body> on first open
    // removes the dependency entirely, whatever the theme does upstream.
    if (modal.parentNode !== document.body) document.body.appendChild(modal);
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';   // the page must not scroll behind it
    var x = modal.querySelector('[data-pcg-p101m-close]');
    if (x && x.focus) x.focus();
  }
  function close() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-pcg-how]')) { open(e); return; }
    if (e.target.closest && e.target.closest('[data-pcg-p101m-close]')) { close(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();
